import { ReactNode } from 'react';
import {
  TableBody as MUITableBody,
  TableBodyProps as MUITableBodyProps,
} from '@mui/material';

type AtomMUIProps = {
  children?: ReactNode;
  classes?: any;
};

export type TableBodyProps = AtomMUIProps;

const TableBody = (props: TableBodyProps) => {
  const MUIProps: MUITableBodyProps = props;

  return <MUITableBody {...MUIProps} />;
};

export default TableBody;
